import { menuAnatomy } from '@chakra-ui/anatomy'
import {
  createMultiStyleConfigHelpers,
  Menu as ChakraMenu,
} from '@chakra-ui/react'
import { ReactElement } from 'react'

import { MenuProps } from './Menu.types'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys)

const hubMenuVariant = definePartsStyle({
  button: {
    width: '13.75rem',
    height: '2.5rem',
    backgroundColor: 'gray.50',
    color: 'gray.800',
    borderRadius: '0.5rem',
    padding: '0.25rem',
    gap: '0.5rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    _hover: {
      backgroundColor: 'gray.100',
    },

    '@media screen and (min-width: 768px)': {
      '&': {
        width: '20rem',
      },
    },
  },
  list: {
    padding: '0.25rem',
    alignItems: 'center',
    gap: '1.5rem',
    borderRadius: '0.5rem',
    border: '0.0625rem solid',
    borderColor: 'gray.300',
    backgroundColor: 'white',
    width: '15rem',
    maxHeight: '80dvh',
    overflow: 'auto',

    '@media screen and (min-width: 768px)': {
      '&': {
        width: '20rem',
      },
    },
  },
  item: {
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    gap: '0.5rem',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    _hover: {
      borderRadius: '0 0.5rem 0.5rem 0',
      borderLeft: '0.125rem solid',
      borderLeftColor: 'blue.500',
      background: 'blue.50',
    },
    '&[aria-selected=true]:hover': {
      backgroundColor: 'gray.100',
      border: 'none',
      borderRadius: '0.5rem',
    },
  },
})

const hubTOVariant = {
  ...hubMenuVariant,
  button: {
    ...hubMenuVariant.button,
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'gray.200',
    _active: {
      backgroundColor: 'white',
    },
    _expanded: {
      backgroundColor: 'white',
    },
  },
  item: {
    ...hubMenuVariant.item,
    '&:disabled': {
      opacity: '1',
      color: 'blue.500',
    },
    '&[aria-selected=true]': {
      color: 'blue.500',
    },
  },
}

export const menuStyle = defineMultiStyleConfig({
  variants: {
    hubMenu: hubMenuVariant,
    hubTO: hubTOVariant,
  },
})

export default function Menu(props: MenuProps): ReactElement {
  return <ChakraMenu {...props} />
}
